import "@sms/design-system/tokens/global.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { Client } from "@sms/sdk";

import { AttendanceForm } from "./features/attendance/AttendanceForm";

const root = document.getElementById("root");
if (!root) throw new Error("classroom-app: #root missing in index.html");

const client = new Client({
  baseURL: typeof window !== "undefined" ? window.location.origin : "",
});

createRoot(root).render(
  <StrictMode>
    <AttendanceForm locale="ne" client={client} />
  </StrictMode>,
);
